export const DEFAULT_ENDPOINT = 'https://ingest.onelence.com';

